import styled from 'styled-components'
import { SectionTransparent } from '../ui/SectionTransparent';
import { TextInput } from '../ui/TextInput';

export const SectionContainerTransparent = styled(SectionTransparent)`
  max-width: 720px;
  text-align: center;
  font-size: 1.3rem;
  gap: 16px;
  width: 100%;
`

export const StyledTextInput = styled(TextInput)`
  width: 100%;
`